import { CardsProps } from "@amzn/awsui-components-react/polaris/cards/interfaces";
import React from "react";
import { Button, Icon } from "@amzn/awsui-components-react";
import { LaunchWorkflowData } from "@amzn/coral_com-amazon-deviceslaunchcontrolservice";
import { exportCSV, getTimestampedCsvFileName } from "../../util/fileUtils";
import { trackButtonClick } from "../telemetry/telemetry";
import { getCountryCode } from "../../from-server/acs/acs-service";

export const SUBMISSION_CARD_DEFINITION: CardsProps.CardDefinition<any> = {
  header(item: any): React.ReactNode {
    return "Workflow Id";
  },
  sections: [
    {
      id: "workflowId",
      header: "",
      content(item: LaunchWorkflowData): React.ReactNode {
        return item.workflowId;
      },
    },
    {
      id: "workflowType",
      header: "Workflow Type",
      content(item: any): React.ReactNode {
        return <div>{item.workflowType}</div>;
      },
    },
    {
      id: "status",
      header: "Status",
      content(item: LaunchWorkflowData): React.ReactNode {
        let icon = <Icon variant="success" name="status-positive" />;
        if (item?.overallStatus?.toLowerCase().includes("partial")) {
          icon = <Icon variant="warning" name="status-warning" />;
        } else if (item?.overallStatus?.toLowerCase().includes("fail")) {
          icon = <Icon variant="error" name="status-negative" />;
        }
        return (
          <div>
            {icon} {item.overallStatus ? item.overallStatus : "Unknown"}
          </div>
        );
      },
    },
    {
      id: "asinCount",
      header: "ASIN-Marketplaces",
      content(item: LaunchWorkflowData): React.ReactNode {
        return item.asinMarketplaceResults?.length;
      },
    },
    {
      id: "requester",
      header: "Requester",
      content(item: LaunchWorkflowData): React.ReactNode {
        return `${item.requester?.identity}@`;
      },
    },
    {
      id: "requestTime",
      header: "Submitted at",
      content(item: LaunchWorkflowData): React.ReactNode {
        return item?.requestTime
          ? new Date(item.requestTime).toISOString()
          : "Unknown";
      },
    },
    {
      id: "lastUpdatedAt",
      header: "Last Updated at",
      content(item: LaunchWorkflowData): React.ReactNode {
        return item?.lastUpdatedTime
          ? new Date(item.lastUpdatedTime).toISOString()
          : "Unknown";
      },
    },
    {
      id: "details",
      header: "Details",
      content(item: LaunchWorkflowData): React.ReactNode {
        return (
          <Button
            iconName={"download"}
            children={"Download"}
            onClick={(event) => {
              trackButtonClick("oneClickLaunchTable", "Download", {});
              // Format the data AsinMarketplace level Result (AsinMarketplaceResult) data for export.
              const results: any[] = (item.asinMarketplaceResults || []).map(
                (item: any) => {
                  return {
                    ASIN: item.asin,
                    Country: getCountryCode(item.obfuscatedMarketplaceId),
                    Payload: item.payload,
                    "Submission Status": item.submissionStatus,
                  };
                }
              );

              const currDate = new Date();
              const fileName = [
                currDate.toLocaleDateString(),
                currDate.toLocaleTimeString(),
                item.workflowType,
                item.requester?.identity || "Unknown",
                item.workflowId,
              ].join("_");

              exportCSV({
                fileName: `${fileName}.csv`,
                csvData: results.length > 0 ? (results as [{}]) : [{}],
              });
            }}
          />
        );
      },
    },
  ],
};
